import defaultTheme from "./default.theme";
const index = {
    defaultTheme
};
export default index;
